import styled from "styled-components";
import theme from "../../../../Themes/light";

export const ContainerOpcoesDeFrete = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 6rem;
  padding: 0rem 12rem;
  max-width: 90vw;

  > .containerImagem {
    min-width: 60%;

    > .imagem {
      width: 100%;
    }
  }

  > .containerTexto {
    min-width: 40%;
    text-align: left;

    > span {
      color: ${(props) => props.theme.colors.secondary};
      font-weight: bold;
    }
  }

  @media (max-width: 1024px) {
    padding: 0rem 6rem;
    flex-direction: column;

    .containerImagem {
      width: 100%;

      .imagem {
        max-width: 50rem;
      }
    }

    .containerTexto {
      text-align: center;
    }
  }
`;
